import { render } from "./TemplateDetail.vue?vue&type=template&id=25ac84e5&scoped=true&ts=true"
import script from "./TemplateDetail.vue?vue&type=script&lang=ts"
export * from "./TemplateDetail.vue?vue&type=script&lang=ts"

import "./TemplateDetail.vue?vue&type=style&index=0&id=25ac84e5&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ac84e5"]])

export default __exports__